import React, { useCallback, useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import CardNews from "../NewsPage/uis/SectionNews/CardNews";
import { useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setAcademiaHeaderUrl,
  setAcademiaSearch,
  setAcademiaSearchList,
  setBookmarkUrls,
  setCitationPopup,
  setCollections,
  setShowCharity,
  setSummarizePopup,
} from "../../redux/features/dataSlice";
import { getConfig, searchAPI } from "../../apis";
import NewsRating from "../NewsPage/uis/SectionNews/NewsRating";
import useInfiniteScrollCategory from "../../hooks/useInfiniteScrollCategory";
import NewBookmark from "./NewBookmark";
import { logEvent } from "../../functions/amplitude";
import CustomLoader from "../../components/loader";
import Datepicker from "../../components/datepicker/Datepicker";
import PopupSave from "../NewsPage/uis/SectionNews/PopupSave";
import CustomSummarize from "../NewsPage/uis/SectionNews/CustomSummarize";
import PopupCitation from "../SavedPage/popup/PopupCitation";
import { toast } from "react-toastify";
import AcademiaNews from "../NewsPage/uis/SectionNews/AcademiaNews";
import MenuPrimary from "../../components/menu/MenuPrimary";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import {
  AcademiaLabels,
  AcademiaOptions,
  AcademiaOptionsLabels,
  academiaDescription,
} from "../../constants";
import Summarize from "../NewsPage/uis/SectionNews/Summarize";
import { axiosInstance } from "../../functions/axios";
import useDocumentTypes from "../../hooks/useDocumentTypes";

export const dataCount = (academiaSearch) => {
  return academiaSearch === "Academia" || academiaSearch === "Bing" ? 21 : 10;
};

const NewsCategoryPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [infoPopup, setinfoPopup] = useState(false);
  const [shouldFetchData, setShouldFetchData] = useState(true);
  const [newBookmarkPopup, setNewBookmarkPopup] = useState(false);
  const [selectedCollection, setselectedCollection] = useState({});
  const [saveBookmarkPopup, setSaveBookmarkPopup] = useState(false);
  const [bookmarkdata, setBookmarkData] = useState({});
  const [summaryText, setSummaryText] = useState("");
  const [desc, setDesc] = useState("");
  const [isDescExternal, setIsDescExternal] = useState(false);
  const [summarizePopupNa, setSummarizePopupNa] = useState(false);
  const [articleData, setArticleData] = useState({});
  const [citation, setCitation] = useState("");
  const [label, setLabel] = useState("Try This!");
  const [categoryData, setcategoryData] = useState([]);
  const [summaryAvailable, setSummaryAvailable] = useState(false);
  const [citationAvailable, setCitationAvailable] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(
    localStorage.getItem("category") ? true : false
  );

  const { category } = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");

  const [loading, setloading] = useState(true);

  const { popupCardFooter } = useSelector((state) => state.styles);

  const {
    bookmarkUrls,
    datePicker,
    summarizePopup,
    summaryPopup,
    citationPopup,
    academiaSearch,
    academiaSearchList,
  } = useSelector((state) => state.data);

  const { user } = useSelector((state) => state.auth);
  useDocumentTypes(user.userId);

  const [offset, setoffset] = useState(
    localStorage.getItem("category") ? 21 : 0
  );

  const ugc = localStorage.getItem("ugc")
    ? localStorage.getItem("ugc").replace(/"/g, "")
    : "";

  // if (localStorage.getItem("academiaSearch")) {
  //   dispatch(setAcademiaSearch(localStorage.getItem("academiaSearch")));
  // }

  const { hasMore, scrollLoading, error } = useInfiniteScrollCategory(
    offset,
    setloading,
    academiaSearch,
    categoryData,
    setcategoryData,
    setoffset,
    setShouldLoad
  );

  const observer = useRef();

  const getAcademiaSearchList = async () => {
    try {
      const { data } = await axiosInstance.post(
        searchAPI.academiaSearchList,
        {
          userId: user.userId,
        },
        getConfig()
      );
      dispatch(setAcademiaSearchList(data));
      const labelVal = data.filter((val) => val.categoryName_chr === type)[0]
        .displayName_chr;
      setLabel(labelVal);
    } catch (e) {
      console.log(e.message);
    }
  };

  const lastElementRef = useCallback(
    (node) => {
      if (scrollLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          if (academiaSearch === "Bing" || academiaSearch === "Academia")
            setoffset(
              (prevOffset) => (prevOffset + 1) * dataCount(academiaSearch)
            );
          else {
            setoffset((prevOffset) => prevOffset + 10);
          }
        }
      });
      if (node) observer.current.observe(node);
    },
    [scrollLoading, hasMore]
  );

  const handleDataFetch = () => {
    setShouldFetchData(true);
  };

  async function getCollectionData() {
    const res = await axiosInstance.post(
      searchAPI.getCollections,
      {
        callingUserId: user.userId,
        userId: user.userId,
      },
      getConfig()
    );

    let newArr = [];
    res.data.forEach((item) =>
      newArr.push({
        name: item.collectionName_chr,
        value: item.collectionName_chr,
        collectionId: item.collectionID_ids,
        parentCollectionId: item.parentCollectionID_lng,
      })
    );
    newArr = newArr.reverse();
    dispatch(setCollections(newArr));
    setselectedCollection(JSON.stringify(newArr[0]));
  }

  const saveCollectionFolder = async (name) => {
    const requestsData = {
      callingUserId: user.userId,
      userId: user.userId,
      collectionName: name,
    };
    await axiosInstance.post(
      searchAPI.updateCollections,
      requestsData,
      getConfig()
    );
    getCollectionData();

    setNewBookmarkPopup(false);
  };

  const handleLabelChange = (message, label) => {
    if (label === academiaSearch) {
      return;
    }
    setcategoryData([]);

    setloading(true);
    setoffset(0);
    setLabel(message);
    dispatch(setAcademiaSearch(label));
  };

  const changeType = (option) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("type", option); // Set the "type" parameter to "Semantic"
    navigate({
      pathname: location.pathname,
      search: "?" + searchParams.toString(),
    });
  };

  const handleSavedCollection = async (bookmarkId) => {
    try {
      const json_res = {
        ...articleData,
        collectionSourceId: bookmarkId,
        userId: user.userId,
        citation: citation,
      };
      const res = await axiosInstance.post(
        searchAPI.saveCitation,
        json_res,
        getConfig()
      );

      toast.success("Citation saved successfully!");
    } catch (e) {
      console.log(e);
    }
  };

  const isSummaryAvailable = () => {
    const summaryAvailable = academiaSearchList.filter(
      (option) => option.categoryName_chr === academiaSearch
    )[0]?.isSummaryAvailable_ysn;
    setSummaryAvailable(summaryAvailable);
  };

  const isCitationAvailable = () => {
    const citationAvailable = academiaSearchList.filter(
      (option) => option.categoryName_chr === academiaSearch
    )[0]?.isCitationAvailable_ysn;
    setCitationAvailable(citationAvailable);
  };

  const checkNoResults = () => {
    return (
      (categoryData.length === 0 || !Array.isArray(categoryData)) &&
      !shouldLoad &&
      !loading
    );
  };

  useEffect(() => {
    const getBookmarks = async () => {
      const res = await axiosInstance.post(
        searchAPI.getCollectionsSource,
        {
          callingUserId: user.userId,
          userId: user.userId,
        },
        getConfig()
      );
      dispatch(
        setBookmarkUrls(res.data.map((bookmark) => bookmark.sourceUrl_chr))
      );
    };
    if (shouldFetchData) {
      getBookmarks();
      setShouldFetchData(false);
    }

    getBookmarks();
  }, [shouldFetchData]);

  useEffect(() => {
    if (popupCardFooter) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [popupCardFooter]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setoffset(0);
  }, [loading]);

  useEffect(() => {
    // let academia = localStorage.getItem("academiaSearch");
    // if (!academia) {
    //   localStorage.setItem("academiaSearch", "Academia");
    // }
    if (type) {
      dispatch(setAcademiaSearch(type));
    } else {
      dispatch(setAcademiaSearch("Bing"));
    }
    getAcademiaSearchList();
  }, []);

  useEffect(() => {
    setloading(true);
    return () => {
      setloading(false);
    };
  }, []);

  useEffect(() => {
    if (category === "Academia") {
      isSummaryAvailable();
      isCitationAvailable();
    }
  }, [academiaSearch]);

  useEffect(() => {
    if (academiaSearchList) {
      const option = academiaSearchList.filter(
        (option) => option.categoryName_chr === type
      )[0];
      dispatch(setAcademiaHeaderUrl(option?.hostName_chr));
    }
  }, [type, academiaSearchList]);

  if (loading) {
    return (
      <div className="news-category-page">
        <CustomLoader height="80vh" />
      </div>
    );
  }

  return (
    !loading && (
      <>
        <div className="news-category-page">
          <h3 className="custom-date">{searchParams.get("range")}</h3>
          <div className="flex mb-2">
            <div className="header-link">
              <h3
                onClick={() =>
                  logEvent(`click_result_header`, { result_header: "clicked" })
                }
                className="mr-5"
              >
                {category === "Academia"
                  ? "Academia & Scholarly Resources"
                  : category}
              </h3>
              {category === "Academia" && (
                <MenuPrimary
                  data={academiaSearchList.map((option) => ({
                    name: option.displayName_chr,
                    onClick: () => {
                      setShouldLoad(true);
                      handleLabelChange(
                        option.displayName_chr,
                        option.categoryName_chr
                      );
                      dispatch(setAcademiaHeaderUrl(option.hostName_chr));
                      changeType(option.categoryName_chr);
                    },
                  }))}
                  children={
                    <div className="flex">
                      <p>{label}</p>
                      {}
                      <KeyboardArrowDownOutlinedIcon />
                    </div>
                  }
                />
              )}
              {ugc !== "null" && <p className="ugc">{ugc}</p>}
              {category === "Academia" &&
                (label !== "Academia" || label !== "Try This!") && (
                  <p className="ugc">{academiaDescription(academiaSearch)}</p>
                )}
            </div>
          </div>
          {checkNoResults() ? (
            <div className="no-data">
              <p>No results found</p>
            </div>
          ) : (
            <>
              {newBookmarkPopup && (
                <NewBookmark
                  saveCollectionFolder={saveCollectionFolder}
                  setNewBookmarkPopup={setNewBookmarkPopup}
                  newBookmarkPopup={newBookmarkPopup}
                />
              )}
              <PopupSave
                data={bookmarkdata}
                bookmarkUrls={bookmarkUrls}
                handleDataFetch={handleDataFetch}
                setNewBookmarkPopup={setNewBookmarkPopup}
                selectedCollection={selectedCollection}
                setselectedCollection={setselectedCollection}
                popup={saveBookmarkPopup}
                setpopup={setSaveBookmarkPopup}
                setData={setBookmarkData}
                desc={desc}
                handleSavedCollection={handleSavedCollection}
              />
              <div className="page-content">
                {datePicker && <Datepicker />}
                {Array.isArray(categoryData) &&
                  categoryData.map((item, index) => {
                    // If the category is "Academia", render the AcademiaNews component.
                    if (category === "Academia") {
                      return academiaSearch === "Academia" ? (
                        <CardNews
                          key={index}
                          data={{
                            ...item,
                            charityNavigatorRating: null,
                            charityNavigatorScore: null,
                          }}
                          cardRef={
                            categoryData?.length === index + 1
                              ? lastElementRef
                              : undefined
                          }
                          bookmarkUrls={bookmarkUrls}
                          setSaveBookmarkPopup={setSaveBookmarkPopup}
                          setBookmarkData={setBookmarkData}
                          academiaSearch={academiaSearch}
                          sectionTitle={category}
                        />
                      ) : (
                        <AcademiaNews
                          key={index}
                          data={item}
                          cardRef={
                            categoryData?.length === index + 1
                              ? lastElementRef
                              : undefined
                          }
                          bookmarkUrls={bookmarkUrls}
                          setSaveBookmarkPopup={setSaveBookmarkPopup}
                          setBookmarkData={setBookmarkData}
                          academiaSearch={academiaSearch}
                          sectionTitle={category}
                          label={academiaSearch}
                          summaryAvailable={summaryAvailable}
                          citationAvailable={citationAvailable}
                        />
                      );
                    }

                    // Otherwise, render the CardNews component.
                    return (
                      <CardNews
                        key={index}
                        data={item}
                        cardRef={
                          categoryData?.length === index + 1
                            ? lastElementRef
                            : undefined
                        }
                        bookmarkUrls={bookmarkUrls}
                        setSaveBookmarkPopup={setSaveBookmarkPopup}
                        setBookmarkData={setBookmarkData}
                        sectionTitle={category}
                      />
                    );
                  })}
              </div>
            </>
          )}
          {scrollLoading && (
            <div className="loading-more">
              <CustomLoader size="3rem" />
            </div>
          )}

          {infoPopup && (
            <div className="popover-info">
              <div className="bg-dark" />

              <div className="info-popup">
                <CloseIcon
                  className="cross"
                  onClick={() => setinfoPopup(false)}
                />

                <h3 className="mb-2">Global News</h3>
                <p className="mb-2">
                  Includes major print and online news and information outlets
                  covering national and international news with a strong
                  emphasis on daily original reporting. All Global News sources
                  have been rated by NewsGuard for reliability. We do not
                  include any news sources that score below 60 (out of 100), per
                  NewsGuard’s rating system (see below for more information on
                  NewsGuard.)
                </p>
                <ButtonPrimary
                  text="Close"
                  onClick={() => setinfoPopup(false)}
                />
              </div>
            </div>
          )}
          {popupCardFooter && <NewsRating />}
          {console.log(summarizePopup)}
          {summarizePopup && (
            <Summarize
              setSaveBookmarkPopup={setSaveBookmarkPopup}
              desc={desc}
              setDesc={setDesc}
              isDescExternal={isDescExternal}
              setIsDescExternal={setIsDescExternal}
              setSummaryText={setSummaryText}
              summaryText={summaryText}
              summarizePopupNa={true}
              setSummarizePopupNa={() => {}}
            />
          )}
          {summaryPopup && (
            <CustomSummarize
              setDesc={setDesc}
              setIsDescExternal={setIsDescExternal}
              setSummaryText={setSummaryText}
              summaryText={summaryText}
              setSummarizePopupNa={setSummarizePopupNa}
            />
          )}
          <PopupCitation
            citationPopup={citationPopup}
            setCitationPopup={setCitationPopup}
            setBookmarkData={setBookmarkData}
            articleData={articleData}
            setArticleData={setArticleData}
            citation={citation}
            setCitation={setCitation}
            setSaveBookmarkPopup={setSaveBookmarkPopup}
          />
        </div>
      </>
    )
  );
};

export default NewsCategoryPage;
